import {Box, Card, CardContent, Tab, Tabs, Typography} from "@mui/material";
import {kontakteStyles} from "../../../styles/kontakte/kontakte.styles";
import TabPanel from "./TabPanel";
import React, {useState} from "react";
import {useKontakteHandling} from "../../../hooks/kontakte/useKontakteHandling";

interface TabTranscriptCardProps {
    transkript?: string | null | undefined;
    transkriptDeutsch?: string | null | undefined;
}

export default function TabTranscriptCard({transkript,transkriptDeutsch}: TabTranscriptCardProps) {
    const { translation } = useKontakteHandling();
    const [transcriptTab, setTranscriptTab] = useState<number>(0);

    function a11yProps(index: number) {
        return {
            id: `transcript-tab-${index}`,
            'aria-controls': `transcript-tabpanel-${index}`,
        };
    }
    return (
        <Card>
            <CardContent>
                <Typography variant="h6" gutterBottom>
                    {translation("transcript")}
                </Typography>
                <Box sx={kontakteStyles.transcriptTabBox}>
                    <Tabs
                        value={transcriptTab}
                        onChange={(_event, newValue) => setTranscriptTab(newValue)}
                        aria-label="transcript language tabs"
                    >
                        <Tab label={translation("transcript-language-original")} {...a11yProps(0)} />
                        <Tab label={translation("transcript-language-german")} {...a11yProps(1)} />
                    </Tabs>
                    <TabPanel value={transcriptTab} index={0}>
                        <Box sx={kontakteStyles.transcriptBox}>
                            <Typography variant="body2" style={kontakteStyles.transcriptBody}>
                                {transkript || translation("transcript-language-original-no-transcript")}
                            </Typography>
                        </Box>
                    </TabPanel>
                    <TabPanel value={transcriptTab} index={1}>
                        <Box sx={kontakteStyles.transcriptBox}>
                            <Typography variant="body2" style={kontakteStyles.transcriptBody}>
                                {transkriptDeutsch || translation("transcript-language-german-no-transcript")}
                            </Typography>
                        </Box>
                    </TabPanel>
                </Box>
            </CardContent>
        </Card>
    )
}
